enum PortfolioItemWithGroupsPromptVariant {
  TOPIC = 'topic',
  SUBTOPIC = 'subtopic',
  PART = 'part',
  SECTION = 'section',
  FIELD = 'field',
}

export default PortfolioItemWithGroupsPromptVariant;
